import { Trans } from '@frontend/i18n';
import { currency, Text } from '@frontend/design-system';
import { useCareCreditTranslations } from '../../../../hooks/use-care-credit-translations';
import { styles, FinanceOptionDetailsProps } from './finance-option-details-shared';

export const FinanceOptionDetailsFixedApr = ({ financeOption }: FinanceOptionDetailsProps) => {
  const { t } = useCareCreditTranslations();

  return (
    <div className='finance-option-details__fixed-apr' css={styles.root}>
      <Text weight='bold'>{t('Reduced APR and Fixed Monthly Payments Required Until Paid in Full**')}</Text>

      <div className='totals' css={styles.totals}>
        <div>
          <Text>{t('Total Payments With Interest')}</Text>
          <Text weight='bold'>{currency(financeOption.totalAmount, { decimals: 2 })}</Text>
        </div>
        <div>
          <Text>{t('Required Payments')}</Text>
          <Text weight='bold'>
            {t('{{amount}}/month', {
              amount: currency(financeOption.requiredPayment, { decimals: 0 }),
            })}
          </Text>
        </div>
        <div>
          <Text>{t('Promo Period')}</Text>
          <Text weight='bold'>{t('{{months}} months', { months: financeOption.period })}</Text>
        </div>
      </div>

      <Text>
        <Trans t={t}>
          The estimated required monthly payment shown equals the Amount Financed multiplied by 4.9876%. It is rounded
          to the next highest whole dollar. The sum of the required monthly payments will equal the cost of the Amount
          Financed. During the last month(s) of the promo period, the required monthly payment may be reduced due to the
          prior months' rounding. If you make these payments by the due date each month, you should pay off the Amount
          Financed within the promo period, if it is the only balance you are paying off. If you have other balances on
          your account, this payment will be added to any other minimum monthly payments.
        </Trans>
      </Text>

      <Text>
        <Trans t={t}>
          IMPORTANT: The information about the required fixed monthly payment shown assumes the following promo
          financing offer is applied to the Amount Financed:
        </Trans>
      </Text>

      <Text weight='bold'>
        {t('{{interest}}% APR and Fixed Monthly Payments Required for {{months}} Months**', {
          interest: financeOption.interestRate,
          months: financeOption.period,
        })}
      </Text>

      <Text>
        <Trans t={t}>
          ** Interest will be charged on promo purchase from the purchase date at a reduced APR shown and fixed. Monthly
          payments are required until paid in full. These payments may be higher than the minimum payment that would be
          required if the purchase was a non-promo purchase. Regular account terms apply to non-promo purchases.
          Accounts as of 5/30/2024: Purchase APR is 32.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2.
          Existing cardholders: See your credit card agreement terms. Subject to credit approval. We reserve the right
          to discontinue or alter the terms of this offer at any time.
        </Trans>
      </Text>
    </div>
  );
};
